import {
  GET_ALL_PENDING_POD_SUMMARY_REQUEST,
  GET_ALL_PENDING_POD_SUMMARY_SUCCESS,
  GET_ALL_PENDING_POD_SUMMARY_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getPendingPodSummary = (token, values) => (dispatch) => {
  console.log("values", values)
  let cleanedVal = (values.customer === undefined || values.customer === null) ? null : values.customer.includes("'") ? values.customer.replace(/'/g, "''") : values.customer;
  let cleanedVal1 = (values.billing_addressee === undefined || values.billing_addressee === null) ? null : values.billing_addressee.includes("'") ? values.billing_addressee.replace(/'/g, "''") : values.billing_addressee;

  dispatch({ type: GET_ALL_PENDING_POD_SUMMARY_REQUEST });
  const newData = {
    ship_header_no: values.ship_no === undefined || values.ship_no === "" ? null : values.ship_no,
    order_header_no: values.order_no === undefined || values.order_no === "" ? null : values.order_no,
    date_from: moment(values.from_date).format("MM-DD-YYYY"),
    date_to: moment(values.to_date).format("MM-DD-YYYY"),
    reference_no: values.po_no === undefined || values.po_no === "" ? null : values.po_no,
    customer: cleanedVal === undefined || cleanedVal === "" ? null : cleanedVal,
    bill_addressee: cleanedVal1 === undefined || cleanedVal1 === "" ? null : cleanedVal1,
    sp_id: values.sale_person === "All" || values.sale_person === undefined ? null : values.sale_person,
    region_id: ( values.region === "All" || values.region === undefined ) ? null : values.region.toString(),
    gender_id: values.gender === "All" || values.gender === undefined ? null : values.gender,
    payment_term_id: values.terms === "All" || values.terms === undefined ? null : values.terms,
    company_id: values.subsidary === "All" || values.subsidary === undefined ? null : values.subsidary,
    status_id: values.status === undefined || values.status === "All" ? null : values.status,
    ship_status_id: values.ship_status === undefined || values.ship_status === "All" ? null : values.ship_status,
    location_id: values.location === undefined || values.location === "All" ? null : values.location,
    customer_id: values.customerNew === undefined ? null : values.customerNew,
    tracking_status: values.tracking_status === undefined || values.tracking_status === "All" ? null : values.tracking_status,
    sku: (values.sku === undefined || values.sku === "") ? null : values.sku,
    customer_cat_id: values.cutomer_category === "All" || values.cutomer_category === undefined ? null : values.cutomer_category,
  };

  return axios({
    method: "POST",
    url: `${BASEURL}getAll/GetOmsPodSummary`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_ALL_PENDING_POD_SUMMARY_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_ALL_PENDING_POD_SUMMARY_ERROR,
        payload: [],
      });
    });
};
